import { Factory } from "@/data/dao/Factory";
import { DaoError } from "@/data/dao/service/BaseServiceDao";
import { LogsDao } from "@/data/dao/service/LogsDao";
import { LogLevel } from "@/data/model/Enums";

import { loggingConfig } from "./Config";

export class Logging {
    static LogApiCall(message: string) {
        if (loggingConfig.enableApiCallsLogging) console.log(`[${new Date().toISOString()}] ${message}`);
    }

    static LogSocketNotification(message: string) {
        if (loggingConfig.enableSocketNotificationsLogging) console.log(`[${new Date().toISOString()}] ${message}`);
    }

    static LogTrace(message: string) {
        const logMessage = `[${new Date().toISOString()}] Trace: ${message}`;
        console.log(logMessage);

        Logging.AddLogMessage(logMessage, LogLevel.Trace);
    }

    static LogDebug(message: string) {
        const logMessage = `[${new Date().toISOString()}] Debug: ${message}`;
        console.log(logMessage);

        Logging.AddLogMessage(logMessage, LogLevel.Debug);
    }

    static LogInfo(message: string) {
        const logMessage = `[${new Date().toISOString()}] Info: ${message}`;
        console.log(logMessage);

        Logging.AddLogMessage(logMessage, LogLevel.Information);
    }

    static LogWarning(message: string) {
        const logMessage = `[${new Date().toISOString()}] Warning: ${message}`;
        console.log(logMessage);

        Logging.AddLogMessage(logMessage, LogLevel.Warning);
    }

    static LogError(e: any) {
        try {
            let logMessage = `[${new Date().toISOString()}] `;

            if (e instanceof DaoError) {
                const daoError = e as DaoError;

                // general http error
                if (!daoError.type) {
                    logMessage += `Network error, Reason: ${daoError.baseReason}, Status: ${daoError.baseContext?.statusText} ${daoError.baseContext?.status}. Stack: ${daoError.callStack}`;
                } else {
                    logMessage += `Backend error occurred: ${daoError.type}. Stack: ${daoError.callStack}`;
                }
            } else if (e instanceof Error) {
                // Handling built-in JavaScript exceptions
                logMessage += `JS Exception [${e.name}]: ${e.message}. Stack: ${e.stack}`;
            } else {
                // Handling errors that are not instances of Error (e.g., atypical objects or data)
                logMessage += `Unknown error format: ${JSON.stringify(e)}`;
            }

            console.log(logMessage);
            console.error(e);

            Logging.AddLogMessage(logMessage, LogLevel.Error);
        } catch (newError) {
            console.error("Error during logging:", newError);
        }
    }

    private static async AddLogMessage(message: string, level: LogLevel) {
        if (level < loggingConfig.minLogLevelToSend) return;

        const logsDao = Factory.getInstance<LogsDao>(LogsDao);
        try {
            await logsDao.addMessage(message, level);
        } catch (ex) {
            console.error(ex);
        }
    }
}
